<template>
  <div v-if="shouldShow"
    class="bg-white rounded-lg shadow p-4 w-full border border-gray-200 mb-3 flex flex-col lg:flex-row lg:items-center gap-4">

    <!-- Icono -->
    <div class="w-12 h-12 rounded-full bg-purple-500 flex items-center justify-center flex-shrink-0">
      <i class="bx bxs-rocket text-white text-2xl"></i>
    </div>

    <!-- Estado 3: reward activado -->
    <div v-if="isRewardActivated" class="flex-1 flex items-center gap-2">
      <i class="bx bx-calendar text-green-600"></i>
      <p class="text-sm text-green-800 font-medium">
        Tu oferta está reservada y se aplicará al finalizar tu prueba el
        <strong>{{ rewardApplyDate }}</strong>
      </p>
    </div>

    <!-- Estado 1 y 2: en progreso o dismissed -->
    <div v-else class="flex-1">
      <div class="flex items-center gap-2 mb-1">
        <span class="text-base font-bold text-gray-800">
          {{ isComplete ? '🎁 ¡Tienes un beneficio pendiente!' : '🎁 Ahorra en tu primer mes de Samii' }}
        </span>
      </div>
      <div class="text-sm text-gray-600">
        <div v-if="isComplete">
          Ya completaste tu onboarding. Activa tu
          <span class="text-purple-700 font-bold">PRIMER MES PREMIUM</span>
          al precio del plan <span class="font-bold text-gray-800">BÁSICO</span>.
        </div>
        <div v-else>
          Completa tu onboarding y recibe
          <span class="text-purple-700 font-bold">PRIMER MES PREMIUM</span>
          al precio del plan <span class="font-bold text-gray-800">BÁSICO</span>
        </div>
      </div>
      <div class="flex items-center gap-1 mt-1 text-xs text-gray-400">
        <i class="bx bx-time-five"></i>
        <span>{{ trialBadgeTitle }}</span>
      </div>
      <div class="flex items-center gap-2 mt-2 flex-wrap">
        <span :class="trialBadgeClass" class="px-3 py-1 rounded-full text-xs font-semibold">
          {{ trialBadgeLabel }}
        </span>
      </div>
      <p class="text-xs text-gray-400 mt-1">{{ trialBadgeDescription }}</p>
    </div>

    <!-- Botón (solo si no está activado) -->
    <div v-if="!isRewardActivated" class="flex-shrink-0">
      <sa-button class="text-center" @click="handleCtaClick">
        {{ isComplete ? 'Activar mi beneficio →' : 'Continuar onboarding →' }}
      </sa-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AccountComplianceBanner',
  computed: {
    accountCompliance() {
      return this.$store.state.account.accountCompliance;
    },
    shouldShow() {
      const c = this.accountCompliance;
      if (!c) return false;
      return this.$moment(c.createdAt).isSameOrAfter('2026-03-18', 'day');
    },
    isRewardActivated() {
      return this.accountCompliance?.rewardActivatedAt;
    },
    rewardApplyDate() {
      const end = this.$store.state.account.membershipEndDate;
      if (!end) return '';
      return this.$moment(end).format('D [de] MMMM');
    },
    trialDaysLeft() {
      const end = this.$store.state.account.membershipEndDate;
      if (!end) return null;
      return this.$moment(end).diff(this.$moment(), 'days');
    },
    trialBadgeLabel() {
      const d = this.trialDaysLeft;
      if (d === null) return '';
      if (d <= 0) return 'Último día disponible';
      if (d <= 3) return `Quedan ${d} días`;
      return `${d} días restantes`;
    },
    trialBadgeClass() {
      const d = this.trialDaysLeft;
      if (d === null) return '';
      if (d <= 0) return 'bg-red-100 text-red-700';
      if (d <= 3) return 'bg-amber-100 text-amber-700';
      return 'bg-purple-100 text-purple-700';
    },
    trialBadgeTitle() {
      const d = this.trialDaysLeft;
      if (d === null) return '';
      if (d <= 0) return 'Hoy finaliza tu prueba gratuita';
      if (d <= 3) return 'Tu prueba gratuita termina pronto';
      return 'Tu prueba gratuita finaliza pronto';
    },
    trialBadgeDescription() {
      const d = this.trialDaysLeft;
      if (d === null) return '';
      if (d <= 0) return 'Activa hoy tu beneficio para mantener tu descuento del primer mes.';
      if (d <= 3) return 'Activa tu beneficio ahora para no perder tu descuento.';
      return `Puedes activar tu beneficio en cualquier momento antes de que termine.`;
    },
    steps() {
      const c = this.accountCompliance || {};
      return [
        {
          key: 'practiceOrder',
          completed: !!c.practiceOrderCompletedAt,
          route: { name: 'orders.create', query: { isTest: true } },
        },
        {
          key: 'businessConfigured',
          completed: !!c.businessConfiguredAt,
          route: { name: 'administration.business' },
        },
        {
          key: 'firstRealOrder',
          completed: !!c.firstRealOrderCompletedAt,
          route: { name: 'orders.create' },
        },
        {
          key: 'firstProduct',
          completed: !!c.firstProductAddedAt,
          route: { name: 'products.create' },
        },
        {
          key: 'reports',
          completed: !!c.reportsVisitedAt,
          route: { name: 'finances.index' },
        },
      ];
    },
    isComplete() {
      return this.steps.every(s => s.completed);
    },
    nextIncompleteStep() {
      return this.steps.find(s => !s.completed) || null;
    },
  },
  methods: {
    handleCtaClick() {
      if (this.isComplete) {
        this.$root.$emit('compliance:open-reward');
      } else {
        this.$router.push(this.nextIncompleteStep.route);
      }
    },
  },
  destroyed() {
    this.$root.$off('compliance:dismissed');
  },
};
</script>